import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import Styles from "../../styles/exercise/viewexercise.module.scss";
import { adminRoutes } from "../../routers/AdminRouters";
import Navbar from "../../components/Navbar";
import Edit from "../../assets/exersise/pencil-edit.png";
import { getCategory, getExerciseById, getOptions } from "../../services";
import { ApiEndpoints } from "../../core";
import { useDispatch, useSelector } from "react-redux";
import { toggle } from "../../redux";
function secondsToHhmmss(totalSeconds) {
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;
  return [hours, minutes, seconds]
    .map((unit) => String(unit).padStart(2, "0"))
    .join(":");
}

const ViewExercise = () => {
  const { exerciseId } = useParams();
  const navigate = useNavigate();
  const [exerciseDetails, setExerciseDetails] = useState({
    name: "",
    category: "",
    type: "",
    hdVideo: "",
    hdVideoSize: "",
    fourKVideo: "",
    fourKVideoSize: "",
    sets: "",
    reps: "",
    tempo: "",
    calories: "",
    meters: "",
    time: "",
    blockTimings: "",
    workPeriods: "",
    restPeriods: "",
  });
  const isSidebarOpen = useSelector((state) => state.navbar.button);
  const dispatch = useDispatch();
  const handleMainContainerClick = () => {
    if (isSidebarOpen) {
      dispatch(toggle());
    }
  };

  useEffect(() => {
    const fetchExercise = async () => {
      try {
        const response = await getExerciseById(exerciseId);

        setExerciseDetails({
          exerciseId: response._id,
          name: response.name || "",
          category: response.category.name || "",
          type: response.type || "",
          hdVideo: response.videos?.primary
            ? `${ApiEndpoints.baseAssetUrl}/${response.videos.primary}`
            : "",
          fourKVideo: response.videos?.secondary
            ? `${ApiEndpoints.baseAssetUrl}/${response.videos.secondary}`
            : "",
          sets: response.variables?.sets || "",
          reps: response.variables?.reps || "",
          tempo: response.variables?.tempos || "", // Fixed key mismatch
          calories: response.variables?.cals || "", // Fixed key mismatch
          meters: response.variables?.meters || "",
          time: response.variables?.time || "", // Add checks if this exists in the response
          blockTimings: response.times?.blockTimings || "",
          workPeriods: response.times?.workPeriods || "",
          restPeriods: response.times?.restPeriods || "",
        });
      } catch (err) {
        console.error("Error fetching exercise details:", err);
      }
    };

    if (exerciseId) {
      fetchExercise();
    }
  }, [exerciseId]);
  console.log(exerciseDetails, "exerciseDetails");

  const handleEdit = (exerciseId) => {
    navigate(`${adminRoutes.editExercise.replace(":exerciseId", exerciseId)}`);
  };
  const handleBack = () => {
    navigate(`${adminRoutes.listExercise}`);
  };
  return (
    <>
      <Navbar />
      <div
        className={Styles.viewexercise_main}
        onClick={handleMainContainerClick}
      >
        <div className={Styles.viewexercise_container}>
          <h2>
            <Link to={adminRoutes.listExercise} className={Styles.white}>
              HOME /
            </Link>{" "}
            <span className={Styles.orange}>VIEW EXERCISE</span>
          </h2>
        </div>
        <div className={Styles.container}>
          <div className={Styles.table_container_heading}>
            <div className={Styles.table_container_headingone}>
              <h3>EXERCISES &nbsp;DETAILS</h3>
            </div>
            <div className={Styles.table_container_headingtwo}>
              <div
                className={Styles.create_new_session}
                onClick={() => handleEdit(exerciseId)}
                style={{ cursor: "pointer" }}
              >
                <img src={Edit} alt="Duplicate Icon" className={Styles.icon} />
                Edit
              </div>
            </div>
          </div>
          <div className={Styles.seperator}>
            <hr className={Styles.line} />
          </div>

          <div className={Styles.row_padding}>
            {/* First Row */}
            <div className={Styles.row}>
              <div className={Styles.info}>
                <div className={Styles.label}>Exercise Name</div>
                <div className={Styles.value}>{exerciseDetails?.name}</div>
              </div>
              <div className={Styles.info}>
                <div className={Styles.label}>Category Name</div>
                <div className={Styles.value}>{exerciseDetails?.category}</div>
              </div>
              {exerciseDetails?.type && (
                <div className={Styles.info}>
                  <div className={Styles.label}>Type</div>
                  <div className={Styles.value}>{exerciseDetails?.type}</div>
                </div>
              )}
              {exerciseDetails.hdVideo && (
                <div className={Styles.info}>
                  <div className={Styles.videocontainerflex}>
                    <div className={Styles.videocontainerflex_box_child}>
                      <video
                        controls={false}
                        src={exerciseDetails.hdVideo}
                        muted
                        className={Styles.video}
                      />
                    </div>
                    <div className={Styles.videocontainerflex_box_child}>
                      <div className={Styles.label}>HD Video</div>
                      <div className={Styles.value}>
                        {`${exerciseDetails.name}.${exerciseDetails.hdVideo
                          .split(".")
                          .pop()}`}
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {exerciseDetails.fourKVideo && (
                <div className={Styles.info}>
                  <div className={Styles.videocontainerflex}>
                    <div className={Styles.videocontainerflex_box_child}>
                      <video
                        controls={false}
                        src={exerciseDetails.fourKVideo}
                        muted
                        className={Styles.video}
                      />
                    </div>
                    <div className={Styles.videocontainerflex_box_child}>
                      <div className={Styles.label}>4K Video</div>
                      <div className={Styles.value}>
                        {`${exerciseDetails.name}.${exerciseDetails.fourKVideo
                          .split(".")
                          .pop()}`}
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
            {/* <div className={Styles.seperator}>
              <span className={Styles.title}>VARIABLE</span> &nbsp;&nbsp;
              <hr className={Styles.line} />
            </div>
            <div className={Styles.row}>
              <div className={Styles.info}>
                <div className={Styles.label}>Sets</div>
                <div className={Styles.value}>{exerciseDetails?.sets}</div>
              </div>
              <div className={Styles.info}>
                <div className={Styles.label}>Reps</div>
                <div className={Styles.value}>{exerciseDetails?.reps}</div>
              </div>
              <div className={Styles.info}>
                <div className={Styles.label}>Tempo</div>
                <div className={Styles.value}>{exerciseDetails?.tempo}</div>
              </div>
              <div className={Styles.info}>
                <div className={Styles.label}>Calories</div>
                <div className={Styles.value}>{exerciseDetails?.calories}</div>
              </div>
              <div className={Styles.info}>
                <div className={Styles.label}>Meters</div>
                <div className={Styles.value}>
                  {" "}
                  {exerciseDetails?.meters === -1
                    ? "Max"
                    : exerciseDetails?.meters}
                </div>
              </div>
              <div className={Styles.info}>
                <div className={Styles.label}>Time</div>
                <div className={Styles.value}>
                  {secondsToHhmmss(exerciseDetails?.time)}
                </div>
              </div>
            </div>
            <div className={Styles.seperator}>
              <span className={Styles.title}>TIMES</span> &nbsp;&nbsp;
              <hr className={Styles.line} />
            </div>
            <div className={Styles.row}>
              <div className={Styles.info}>
                <div className={Styles.label}>Block Timings</div>
                <div className={Styles.value}>
                  {exerciseDetails.blockTimings >= 90
                    ? `${exerciseDetails.blockTimings / 60} minute(s)`
                    : `${exerciseDetails.blockTimings} second(s)`}
                </div>
              </div>
              <div className={Styles.info}>
                <div className={Styles.label}>Work Periods</div>
                <div className={Styles.value}>
                  {exerciseDetails.workPeriods >= 60
                    ? `${exerciseDetails.workPeriods / 60} minute(s)`
                    : `${exerciseDetails.workPeriods} second(s)`}
                </div>
              </div>
              <div className={Styles.info}>
                <div className={Styles.label}>Rest Periods</div>
                <div className={Styles.value}>
                  {exerciseDetails.restPeriods >= 60
                    ? `${exerciseDetails.restPeriods / 60} minute(s)`
                    : `${exerciseDetails.restPeriods} second(s)`}
                </div>
              </div>
            </div> */}
          </div>
          <div className={Styles.seperator}>
            <hr className={Styles.line} />
          </div>
          {/* Back Button */}

          <div className={Styles.actions} onClick={handleBack}>
            <button>Back</button>
          </div>
        </div>
      </div>
    </>
  );
};

export default ViewExercise;
